<template>
<Head>
        <title>Alcalde David de la Peña
        </title>
    </Head>
    <div class="hero-img-overlay " style="background-image: url('/img/hero-comisiones.png');">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-lg-7">
            <h1 class="hero-encabezado">Alcalde David de la Peña</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="bloque-general">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="encabezado-separador"><span>Conoce al Alcalde David de la Peña </span></h2>
          </div>
        </div>
        <div class="row">
            <div class="col-md-3 col-lg-5">
                <img src="/img/alcalde-david-de-la-pena.jpg" alt="Alcalde David de la Peña"/>
            </div>
            <div class="col-md-9 col-lg-7">
                <div class="bio">
                  <p>Orgullosamente santiaguense, al igual que su familia. Casado con la maestra Olga Amalia Villalón Toba, padre de tres hijos: David, Pablo y Maya; actualmente Presidente Municipal de Santiago, Nuevo León y Alcalde Electo para el período 2024-2027.</p>

<p>Convencido de que el servicio p&uacute;blico es un honor y un privilegio, y que es con esfuerzo, disciplina y dedicaci&oacute;n como se logran los verdaderos cambios en nuestra sociedad.</p>

<p>Licenciado en Administraci&oacute;n de Empresas, actualmente cursa la maestr&iacute;a en Gobernanza y Medios de Comunicaci&oacute;n.</p>

<p>Dentro de su vida profesional ha realizado diferentes actividades para el Gobierno del Estado de Nuevo Le&oacute;n, as&iacute; como en el municipio de Guadalupe. En nuestro Municipio, en 2015 fue nombrado Jefe de la Oficina Ejecutiva del Alcalde; posteriormente, en 2018, desempe&ntilde;&oacute; el cargo de Primer Regidor, representando de esta forma a la ciudadan&iacute;a en el Cabildo y ante el Gobierno municipal.</p>

<p>As&iacute; mismo ha participado en actividades pol&iacute;ticas fungiendo como Dirigente Estatal de la Organizaci&oacute;n Juvenil del PRI y Secretario T&eacute;cnico del Comit&eacute; Directivo Estatal del PRI.</p>

<p>En el sector privado me he dedicado al giro restaurantero y de espacios de cowork.</p>

<p>Como Alcalde, mi principal misi&oacute;n es hacer que SANTIAGO siga creciendo y fortaleci&eacute;ndose en el desarrollo econ&oacute;mico, tur&iacute;stico y social, adem&aacute;s de mejorar y mantener la seguridad, permitiendo que, con estas acciones podamos contribuir a elevar la calidad de vida en beneficio de las y los ciudadanos santiaguenses, para que Santiago se viva mejor.</p>

<p>Puedes comunicarte directamente con el alcalde al correo <a href="mailto:david.dlp@santiago.gob.mx">david.dlp@santiago.gob.mx</a></p>

                </div>
            </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {

}
</script>
<style scoped>

</style>
